import React from 'react'
import './style.css'
//import PropTypes from 'prop-types'


const Section = (props) => {

    return(
        <section className='nrt-section' style={props.style}>
            {props.children}
        </section>
    )
}

Section.defaultProps = {

}

export default Section


// WEBPACK FOOTER //
// ./src/components/_common/_containers/Section/index.js